import React from 'react';
import { config } from 'config';
import FontAwesome from 'react-fontawesome';
import '../../node_modules/font-awesome/scss/font-awesome.scss';

import profile from '../../static/img/profile.jpeg';

class Header extends React.Component {
  render() {
    return (
      <header className="header">
        <div className="top-bar container-fluid">
          <div className="actions">
            <a className="btn hidden-xs" href={`mailto:${config.siteEmailUrl}`}><FontAwesome name="paper-plane" aria-hidden="true" /> Hire Me</a>
          </div>
          <ul className="social list-inline">
            <li>
              <a href={config.siteLinkedInUrl}>
                <FontAwesome name="linkedin" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a href={config.siteTwitterUrl}>
                <FontAwesome name="twitter" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a href={config.siteGithubUrl}>
                <FontAwesome name="github-alt" aria-hidden="true" />
              </a>
            </li>
          </ul>
        </div>

        <div className="intro">
          <div className="container text-center">
            <img className="profile-image" src={profile} alt="" />
            <h1 className="name">Alex Maroz</h1>
            <div className="title">Sr. Full Stack Developer</div>
            <div className="profile">
              <p>
                NodeJS/Express, ReactJS, VueJS, Angular, Typescript, ASP.NET Core, Golang,
                Docker, Kubernetes, CD/CD, MongoDB, Postgres, MS SQL
              </p>
            </div>
            <div className="title">
              <b>Current Status</b>
              <br />
              Considering new opportunities for Full-time employment
            </div>
          </div>
        </div>

        <div className="contact-info">
          <div className="container text-center">
            <ul className="list-inline">
              <li className="email"><FontAwesome name="envelope" /><a href={`mailto:${config.siteEmailUrl}`}>{config.siteEmailUrl}</a></li>
            </ul>
          </div>
        </div>

        <div className="page-nav-space-holder hidden-xs">
          <div id="page-nav-wrapper" className="page-nav-wrapper text-center">
            <div className="container">
              <ul id="page-nav" className="nav page-nav list-inline">
                <li><a className="scrollto" href="#skills-section">Skills</a></li>
                <li><a className="scrollto" href="#experiences-section">Experiences</a></li>
                <li><a className="scrollto" href="#education-section">Education</a></li>
                <li><a className="scrollto" href="#contact-section">Contact</a></li>
              </ul>
            </div>
          </div>
        </div>

      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ../components/Header/index.jsx